export function assertsString(v: unknown, msg: string | null = null): asserts v is string {
  if (typeof v !== "string") {
    let errMsg = `expect string, got ${typeof v}.`;
    if (msg) {
      errMsg = `${errMsg} ${msg}`;
    }
    throw Error(errMsg);
  }
}
